import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
export const OrderItemsWrapperStyled = styled.div `
  ${({ isScrollNeeded }) => isScrollNeeded && CustomScroll};
  ${({ isScrollNeeded, isRightToLeft }) => {
    if (!isScrollNeeded) {
        return '';
    }
    return isRightToLeft ? 'padding-left: 16px;' : 'padding-right: 16px;';
}};

  max-height: ${({ isScrollNeeded }) => (isScrollNeeded ? '304px' : 'none')};
  border: none;
`;
export const OrderItemsListStyled = styled.div `
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
`;
